import { Global } from "../Global";
import { SellerInfo } from "../models/Seller"; 
import { post } from "../utils/ApiUtil";

// 获取卖家公开信息
const getSellerInfo = async (sellerIds: string[]): Promise<SellerInfo[]> => {
  if(Global.isMockMode()){
    const mockData = Global.getMockData("getSellerInfo");
    //console.log("mockData:", mockData);
    return mockData;
  }
  const resultOrErrorCode = await post<{ userIds: string[] }, SellerInfo[]>("/buyer/getSellerOpenInfo", { userIds: sellerIds });
  if(typeof resultOrErrorCode === 'string'){
    // 错误码处理
    return [];
  }
  return resultOrErrorCode;
};


export const SellerApi = {
  getSellerInfo
}; 